import { CerFormAdapter } from '@form/cer-form-adapter';
import { CerFormViewSet } from '@form/cer-form-view-set';
import { CerFormPanesSettingsUtil } from '@form/cer-form-panes/cer-form-panes.service';
import { FieldWidthEnum } from '../../cer/cer-data/cer-data-types';
import { CerFormView } from '@form/cer-form-view';

export class DataProcessStageForm extends CerFormAdapter {

  public override viewSetInit(viewSet: CerFormViewSet): void {

    viewSet.panes = CerFormPanesSettingsUtil.masterDetail('horizontal', true, 70);

    const view = this.viewGet();
    viewSet.viewAdd(view);
    viewSet.viewAdd(this.viewStagesPropertyGet(), view);
  }

  private viewGet(): CerFormView {
    const view = new CerFormView();

    view.viewMetadata = {
      name: 'data-proces-stadier', dataApiName: 'DataProcessStage', text: 'Stadier', textSingular: 'Stadie',
      primaryKey: 'id', parentPrimaryKey: 'id', parentForeignKey: 'dataProcess', baseFields: ['id', 'history'], titleFields: ['name']
    };

    //var userId: number = this.appStateService.appUserId();
    view.fieldMetadata =
      [
        { name: 'dataProcess', text: 'Proces', required: true, foreignKeyTableName: 'DataProcess', visible: false, orderBy: 'Ascending', orderByPriority: 1 },
        { name: 'name', text: 'Stadienavn', required: true },
        { name: 'order', text: 'Rækkefølge', required: true, format: 'Integer', orderBy: 'Ascending', orderByPriority: 2 },
        { name: 'responsibleUser', text: 'Ansvarlig medarbejder', widthType: FieldWidthEnum.XXS, foreignKeyTableName: 'User', foreignKeyValue: 'shortName' },
        { name: 'responsibleRole', text: 'Ansvarlig rolle', widthType: FieldWidthEnum.XXS, foreignKeyTableName: 'Role' }
      ];
    return view;
  }

  private viewStagesPropertyGet(): CerFormView {
    const view = new CerFormView();
    view.viewMetadata = {
      name: 'data-proces-stadie-egenskaber', dataApiName: 'DataProcessStageProperty', text: 'Egenskaber', textSingular: 'Egenskab',
      primaryKey: 'id', parentPrimaryKey: 'id', parentForeignKey: 'dataProcessStage', baseFields: ['id', 'history']
    };

    view.fieldMetadata =
      [
        { name: 'dataProcessStage', text: 'Stadie', required: true, foreignKeyTableName: 'DataProcessStage', visible: false, orderBy: 'Ascending', orderByPriority: 1 },
        { name: 'name', text: 'Egenskabnavn', required: true, orderBy: 'Ascending', orderByPriority: 2 },
        { name: 'responsibleUser', text: 'Ansvarlig medarbejder', widthType: FieldWidthEnum.XXS, foreignKeyTableName: 'User', foreignKeyValue: 'shortName' },
        { name: 'responsibleRole', text: 'Ansvarlig rolle', widthType: FieldWidthEnum.XXS, foreignKeyTableName: 'Role' }
      ];


    return view;
  }
}
